import type { TabContextType } from '../types';

const BORDER_WIDTH = 2;
export const scrollTabIntoView = (
    index: number,
    placement: TabContextType['placement'],
    tabGroupNode: HTMLElement | null,
    variant: TabContextType['variant']
) => {
    if (placement === 'left' || placement === 'right' || index === -1) return;
    const tabList = tabGroupNode?.querySelector<HTMLElement>(`[role="tablist"]`);
    const isSegmentedControlVariant = variant === 'segmentedControl' || variant === 'segmentedControlRounded';
    const tabListWidthOffset =
        isSegmentedControlVariant && tabList?.offsetWidth ? tabList?.offsetWidth - BORDER_WIDTH : tabList?.offsetWidth;
    if (tabListWidthOffset === tabList?.scrollWidth) return;
    const selectedTab = tabGroupNode?.querySelectorAll<HTMLElement>(`[role="tab"]`)[index];
    selectedTab?.scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: 'smooth',
    });
};
